
































































































































import Vue from "vue";
import moment from "moment";

// Vue components
import TableFiltersRow from "@/components/TableHeaderFilters/TableFiltersRow.vue";
import BranchFilter from "@/components/TableHeaderFilters/BranchFilter.vue";
import TagsFilter from "@/components/TableHeaderFilters/TagsFilter.vue";
import DateRangeFilter from "@/components/TableHeaderFilters/DateRangeFilter.vue";
import LicenseModuleFilter from "@/components/TableHeaderFilters/LicenseModuleFilter.vue";
import PredictedStatusInstallationChip from "@/views/App/Components/chips/PredictedStatusInstallationChip.vue";
import InstallationPredictedStatusTableHeaderFilter from "@/components/TableHeaderFilters/InstallationPredictedStatusTableHeaderFilter.vue";
import ColumnVisibilityFilter from "@/components/DataTableColumnVisibilityFilter/ColumnVisibilityFilter.vue";
import MachineModelFilter from "@/components/TableHeaderFilters/MachineModelFilter.vue";
import DeviceModelChip from "@/views/App/Components/chips/DeviceModelChip.vue";
import InstallationResumeDialog from "@/components/InstallationResumeDialog.vue";
import PMAlertDialog from "@/views/App/PredictiveMaintenance/PredictiveMaintenance/PMAlertDialog.vue";
// Model
import { LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";
import { dataTableItemsPerPage } from "@/utility/Constants";
import VFaIcon from "@/components/VFaIcon.vue";
import { InstallationPredictedStatus } from "@/model/data/predictiveMaintenance/InstallationPredictedStatus";
import { mapGetters } from "vuex";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";

export default Vue.extend({
    components: {
        TableFiltersRow,
        PredictedStatusInstallationChip,
        VFaIcon,
        ColumnVisibilityFilter,
        DeviceModelChip,
        InstallationResumeDialog,
        PMAlertDialog,
    },
    data() {
        return {
            moment,
            ClientPrivileges,
            prevIcon: "fas fa-chevron-left",
            nextIcon: "fas fa-chevron-right",
            firstTime: true,
            LicenseModuleEnum,
            dataTableItemsPerPage,
            BranchFilter,
            DateRangeFilter,
            LicenseModuleFilter,
            ignoreOptionsChanges: false,
            ignoreDataChanges: false,
            confirmationDialog: false,
            options: {},
            selectedItems: [],
            availableHeaders: [],
            showDialog: false,
            selectedInstallation: null,
            initialAvailableHeaders: [
                {
                    enabled: true,
                    text: this.$t("common.predictedStatus"),
                    value: "predictedInstallationStatus",
                    sortable: false,
                },
                {
                    enabled: true,
                    canBeHidden: false,
                    text: this.$t("common.installationName"),
                    value: "name",
                },
                {
                    enabled: false,
                    canBeHidden: true,
                    text: this.$t("common.tags"),
                    value: "tags",
                    sortable: false,
                },
                {
                    enabled: true,
                    canBeHidden: true,
                    text: this.$t("common.branch"),
                    value: "branch.name",
                },
                {
                    enabled: false,
                    text: this.$t("common.agent_ip"),
                    value: "agentInfo.ip",
                },
                {
                    enabled: false,
                    text: this.$t("device_status.pc_name"),
                    value: "connectedPc",
                },
                {
                    enabled: true,
                    canBeHidden: true,
                    text: this.$t("common.last_update"),
                    value: "lastMessage",
                },
                {
                    enabled: false,
                    text: this.$t("common.last_agent_message"),
                    value: "agentInfo.lastMessage",
                    sortable: true,
                },
                {
                    enabled: true,
                    text: this.$t("common.device/s"),
                    value: "machines",
                    sortable: false,
                },
                {
                    enabled: true,
                    text: this.$t("common.actions"),
                    value: "actions",
                    sortable: false,
                    width: "150px",
                },
            ],
            filters: [
                {
                    headerValue: "predictedInstallationStatus",
                    filterKey: "predictedStatusFilter",
                    component: InstallationPredictedStatusTableHeaderFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "branch.name",
                    filterKey: "branchNames",
                    component: BranchFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "tags",
                    filterKey: "tagValues",
                    component: TagsFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "lastMessage",
                    filterKey: "installationLastMessageDateRange",
                    component: DateRangeFilter,
                    currentSelections: [],
                    description: this.$t("common.dateRangeFilter", { property: this.$t("common.last_installation_message") }),
                },
                {
                    headerValue: "agentInfo.lastMessage",
                    filterKey: "agentLastMessageDateRange",
                    component: DateRangeFilter,
                    currentSelections: [],
                    description: this.$t("common.dateRangeFilter", { property: this.$t("common.last_agent_message") }),
                },
                {
                    headerValue: "machines",
                    filterKey: "machineModels",
                    component: MachineModelFilter,
                    currentSelections: [],
                    customAttrs: LicenseModuleEnum.PredictiveMaintenance,
                },
            ],
        };
    },
    props: {
        loading: { required: true, type: Boolean },
        paginatedTotalItems: Number,
        installations: { required: true, type: Array },
        reqData: Object,
    },
    watch: {
        options: {
            handler(newOptions, oldOptions) {
                if (oldOptions != null) {
                    if (newOptions.page < oldOptions.page) this.prevIcon = "fas fa-circle-notch fa-spin";
                    if (newOptions.page > oldOptions.page) this.nextIcon = "fas fa-circle-notch fa-spin";
                }
                if (!this.ignoreOptionsChanges) this.$emit("options-changed", newOptions);
                else this.ignoreOptionsChanges = false;
            },
            deep: true,
        },
        loading(newVal) {
            if (newVal == false) {
                this.prevIcon = "fas fa-chevron-left";
                this.nextIcon = "fas fa-chevron-right";
            }
        },
        installations: {
            handler(newValue) {
                if (this.firstTime && this.$route.query.options != null && this.$route.query.options != undefined) {
                    let queryOptions = JSON.parse(atob(this.$route.query.options));
                    this.$emit("options-changed", queryOptions);
                    this.options = queryOptions;
                }
                if (
                    this.firstTime &&
                    this.installations.find((i) => i.name == this.$route.query.installation) != undefined &&
                    this.installations.find((i) => i.name == this.$route.query.installation) != null
                ) {
                    if (this.$route.query.showdialog) this.showDialog = this.$route.query.showdialog == "true";
                    if (this.$route.query.installation) this.selectedInstallation = this.installations.find((i) => i.name == this.$route.query.installation);

                    this.firstTime = false;
                }
            },
            deep: true,
        },
    },
    methods: {
        backToTheFirst() {
            if (this.options.page != 1) {
                this.ignoreOptionsChanges = true;
                this.options.page = 1;
                console.debug("backToTheFirst, this.options: ", this.options);
            }
        },
        handleClick(value: InstallationPredictedStatus) {
            if (window.getSelection().toString()) {
                return;
            }
            this.showDialog = true;
            this.selectedInstallation = value;
        },
        newTabDialog(value: any) {
            if (this.reqData) {
                let routeData = this.$router.resolve({
                    name: this.$route.name,
                    query: { showdialog: true, installation: value.name, options: btoa(JSON.stringify(this.options)), reqData: btoa(JSON.stringify(this.reqData)) },
                });
                window.open(routeData.href, "_blank");
            } else {
                let routeData = this.$router.resolve({
                    name: this.$route.name,
                    query: { showdialog: true, installation: value.name, options: btoa(JSON.stringify(this.options)) },
                });
                window.open(routeData.href, "_blank");
            }
        },
    },
    computed: {
        ...mapGetters(["authUserHasPrivilege"]),
    },
});
